'use client'
import { type FC, type ReactNode, createContext, useState, useCallback, useMemo } from 'react'
import { Toast, ToastWrapper, type iToastProps, } from '@/components'

interface iToastState extends iToastProps {
  id: string;
}

export interface ToastContextProps {
  addToast: (toastData: iToastProps) => void;
}

type Props = {
  children: ReactNode
}

export const ToastContext = createContext<ToastContextProps | undefined>(undefined)

export const ToastProvider: FC<Props> = ({ children }) => {
  const [toasts, setToasts] = useState<iToastState[]>([])

  const addToast = useCallback((toastData: iToastProps) => {
    setToasts(prevToasts => [
      ...prevToasts,
      { ...toastData, id: crypto.randomUUID() },
    ])
  }, [])

  const contextValue = useMemo(() => ({ addToast }), [addToast])

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <ToastWrapper aria-live='assertive' aria-atomic='true'>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            {...toast}
            onClose={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))}
          />
        ))}
      </ToastWrapper>
    </ToastContext.Provider>
  )
}
